import Vue from "vue";
import Router from "vue-state-router";

import Home from "../views/Home";

import Overzicht from "../views/site/Overzicht";
import Details from "../views/site/Details";

Vue.use(Router);

export default new Router({
  linkActiveClass: "active",
  routes: [{
      path: "/",
      name: "site",
      components: {
        site: Home,
      },
      children: [{
        path: "/",
        components: {
          sitecontent: Overzicht
        },
        props: {
          content: true
        }
      }, {
        path: '/details/:id/:school_id',
        name: 'details',
        props: {
          sitecontent: true
        },
        components: {
          sitecontent: Details
        }
      }]
    }

  ]
});
